// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label.checkbox {
  --checkbox-width: 20px;
  --checkbox-height: 20px;
  --checkbox-border-radius: 2px;
  --checkbox-border-width: 2px;
  --checkbox-trasition-duration: 300ms;
  --checkbox-color: #4C4F55;
}

label.checkbox {
  position: relative;
  display: block;
  max-width: 100%;
  min-height: var(--checkbox-height);

  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;

  margin: 16px 0;
}

label.checkbox > * {
  vertical-align: middle;
}

.checkbox--proxy {
  position: absolute;
  display: inline-block;
  top: 50%;
  transform: translateY(-50%);
  width: var(--checkbox-width);
  height: var(--checkbox-height);
  border: var(--checkbox-border-width) solid var(--checkbox-color);
  border-radius: var(--checkbox-border-radius);
  background-color: white;
  color: white;
  font-size: 0;
  transition: background-color var(--checkbox-trasition-duration);
}

.checkbox--proxy > svg {
  width: 100%;
  height: 100%;
}

.checkbox--text {
  display: inline-block;
  max-width: 100%;
  padding-left: calc(var(--checkbox-width) + 8px);
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected {
  background-color: var(--checkbox-color);
  transition: background-color var(--checkbox-trasition-duration);
}

.checkbox--tick {
  color: white;
  display: inline-block;
}

.checkbox--dash {
  color: white;
  display: inline-block;
}

.disabled {
  opacity: 0.5;
  cursor: initial;
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/checkbox/checkbox.component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kCAAkC;;EAElC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,gEAAgE;EAChE,4CAA4C;EAC5C,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,+DAA+D;AACjE;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["label.checkbox {\r\n  --checkbox-width: 20px;\r\n  --checkbox-height: 20px;\r\n  --checkbox-border-radius: 2px;\r\n  --checkbox-border-width: 2px;\r\n  --checkbox-trasition-duration: 300ms;\r\n  --checkbox-color: #4C4F55;\r\n}\r\n\r\nlabel.checkbox {\r\n  position: relative;\r\n  display: block;\r\n  max-width: 100%;\r\n  min-height: var(--checkbox-height);\r\n\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n\r\n  margin: 16px 0;\r\n}\r\n\r\nlabel.checkbox > * {\r\n  vertical-align: middle;\r\n}\r\n\r\n.checkbox--proxy {\r\n  position: absolute;\r\n  display: inline-block;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: var(--checkbox-width);\r\n  height: var(--checkbox-height);\r\n  border: var(--checkbox-border-width) solid var(--checkbox-color);\r\n  border-radius: var(--checkbox-border-radius);\r\n  background-color: white;\r\n  color: white;\r\n  font-size: 0;\r\n  transition: background-color var(--checkbox-trasition-duration);\r\n}\r\n\r\n.checkbox--proxy > svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.checkbox--text {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  padding-left: calc(var(--checkbox-width) + 8px);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.selected {\r\n  background-color: var(--checkbox-color);\r\n  transition: background-color var(--checkbox-trasition-duration);\r\n}\r\n\r\n.checkbox--tick {\r\n  color: white;\r\n  display: inline-block;\r\n}\r\n\r\n.checkbox--dash {\r\n  color: white;\r\n  display: inline-block;\r\n}\r\n\r\n.disabled {\r\n  opacity: 0.5;\r\n  cursor: initial;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
